module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAABICAYAAADLV7TnAAABG0lEQVRIS4XK60rCAACA0XzWSpLKxGTdJTNDDRFEjFFRSCKIIIgiSSolXTBGIYUIIsO0m3Y1y9JtvcG+8/sYNFXVRnQYNEWBMBxCGAwg/P1C6Pch/HxD6H1B6HYhfH5AeH+D8PoCodOG8PwE4fEBwn0LQvMOQkOGINch1GsQalX9oFYrECo3EG7LEMpXEK4lCFIJwuU5hItTCGcnEIoFCMc5CPkshKMMhMM0hEwSQioBIRmHkIhBiEchxA4gRMMQInsQwjsQ9kUIu1sQtoMQxACEkB9C0KcflIAXgt8NweeCsOmE4HFA2LBDWF+GsLYIYXUegl2AsGKDsGSFsGCBMGeGIExBsE1CmDVBsE5AsBghzIxDMI9BmB7VDf+c/PQViEKnmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/bar.png
// module id = zBiw
// module chunks = 1